<template>

  <el-form ref="addTextBookRefs" :model="addTextBookForm" :rules="textBookRules" label-width="140px">
    <el-form-item label="园所选择" prop="kindergartenId" style="width:90%">
      <el-cascader
        v-model="addTextBookForm.kindergartenId"
        style="width: 350px;"
        :options="orgGardenTree"
        placeholder="请选择园所"
        clearable
        filterable
        collapse-tags
        :props="{ multiple: false, checkStrictly: false, emitPath: false, label: 'orgName', value: 'orgId',expandTrigger: 'hover' }"
      />
    </el-form-item>
    <el-form-item label="所属科目" prop="subjectId" style="width:60%">
      <GSelect v-model="addTextBookForm.subjectId" :options="selectOptionsSubject" :placeholder="'请选择科目'" @modifyChange="handleChangeSubject" />
    </el-form-item>
    <el-form-item label="教材选择" prop="textBook">
      <el-table
        ref="multipleTable"
        :data="addTextBookForm.textBook"
        :header-cell-style="{'text-align':'center'}"
        tooltip-effect="dark"
        style="width: 100%"
        row-key="index"
        max-height="400"
      >
        <el-table-column width="140" label="教材名称" fixed show-overflow-tooltip>
          <template slot-scope="scope">
            <el-checkbox v-model="scope.row.checked" @change="handleCheckedTextBookName(scope.row)" />
            {{ scope.row.teachingName }}
          </template>
        </el-table-column>
        <el-table-column label="实体书" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-form-item :prop="'textBook.' + scope.$index + '.bookPrice.price'" :rules="scope.row.bookPrice.checked === true ? textBookRules.bookPrice:textBookRules.none">
              <el-checkbox v-model="scope.row.bookPrice.checked" @change="handleClickChangePriceCheck(scope.row.bookPrice,scope.row)">实体书价格：</el-checkbox>
              <el-input v-model="scope.row.bookPrice.price" style="width:40%;margin-right:10px" size="small" onkeyup="value = value.replace(/[^\d.]/g,'')" />元
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="APP课程" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-form-item :prop="'textBook.' + scope.$index + '.teachingPrice.price'" :rules="scope.row.teachingPrice.checked === true ? textBookRules.teachingPrice:textBookRules.none ">
              <el-checkbox v-model="scope.row.teachingPrice.checked" @change="handleClickChangePriceCheck(scope.row.teachingPrice,scope.row)">APP课程价格：</el-checkbox>
              <el-input v-model="scope.row.teachingPrice.price" style="width:40%;margin-right:10px" size="small" onkeyup="value = value.replace(/[^\d.]/g,'')" />元
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="套餐" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-form-item :prop="'textBook.' + scope.$index + '.setmealPrice.price'" :rules="scope.row.setmealPrice.checked === true ? textBookRules.setmealPrice:textBookRules.none">
              <el-checkbox v-model="scope.row.setmealPrice.checked" @change="handleClickChangePriceCheck(scope.row.setmealPrice,scope.row)">套餐价格：</el-checkbox>
              <el-input v-model="scope.row.setmealPrice.price" style="width:40%;margin-right:10px" size="small" onkeyup="value = value.replace(/[^\d.]/g,'')" />元
            </el-form-item>
          </template>
        </el-table-column>

      </el-table>
    </el-form-item>
  </el-form>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import { textBookToTabelFunction } from '../../../utils/reg'
const checkChecked = (rule, value, callback) => {
  try {
    if (!value) {
      callback(new Error('请填入值'))
    } else {
      callback()
    }
  } catch (e) {
    callback(new Error('请填入值'))
  }
}
export default {
  name: 'AddTextBook',
  props: {
    addTextBookForm: {
      type: Object,
      default: () => {
        return {
          graden: '',
          subjectId: '',
          textBook: [
          ],
          subjectName: ''
        }
      }
    }
  },
  data() {
    return {
      addTextBookDialog: false,
      tableData: [],
      textBookRules: {
        none: [],
        subjectName: [{ required: true, message: '请选择科目', trigger: 'blur' }],
        teachingPrice: [{ required: true, message: '请输入app价格', trigger: 'blur' }],
        bookPrice: [{ validator: checkChecked, trigger: 'blur' }],
        teachingGrade: [{ validator: checkChecked, trigger: 'blur' }],
        setmealPrice: [{ validator: checkChecked, trigger: 'blur' }],
        kindergartenId: [
          { required: true, message: '请选择园所', trigger: 'change' }
        ],
        subjectId: [
          { required: true, message: '请选择所属科目', trigger: 'change' }
        ],
        textBook: [
          { required: true, message: '请选择教材', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    ...mapState('commonModule', ['selectOptionsLevel', 'selectOptionsSubject', 'orgGardenTree']),
    ...mapState('gardenManagement', ['selectOptionsGraden', 'selectOptionsType', 'textBookCheckedList', 'checkChecked'])
  },
  watch: {
    textBookCheckedList: function (val) {
      this.addTextBookForm.textBook = textBookToTabelFunction(this.textBookCheckedList)
    }

  },
  created() {
    this.addTextBookForm.textBook = textBookToTabelFunction(this.textBookCheckedList)
  },
  beforeDestroy() {
    this.addTextBookForm.subjectId = ''
    this.SET_RESET()
  },
  methods: {
    ...mapActions('commonModule', ['GET_SUBJECTTREE', 'getOrgTree']),
    ...mapMutations('gardenManagement', ['SET_RESET']),
    ...mapActions('gardenManagement', ['GET_TEXTBOOK_LIST']),
    handleChangeSubject(e) {
      this.GET_TEXTBOOK_LIST(e)
      for (const i of this.selectOptionsSubject) {
        if (e === i.value) {
          this.addTextBookForm.subjectName = i.label
        }
      }
    },
    async addSubmitForm() {
      try {
        const res = await Promise.all([
          this.$refs['addTextBookRefs'].validate(),
          this.$refs['bookPriceForm'].validate(),
          this.$refs['teachingPriceForm'].validate(),
          this.$refs['setmealPriceForm'].validate()
        ])
        console.log(res)
      } catch (error) {
        console.log(error)
      }
    },
    resetAddTextBookForm(target) {
    },
    handleClickChangePriceCheck(obj, fatherObj) {
      if (fatherObj.bookPrice.checked === false && fatherObj.teachingPrice.checked === false && fatherObj.setmealPrice.checked === false) {
        fatherObj.checked = false
      } else if (obj.checked === true) {
        fatherObj.checked = true
      }
    },
    handleCheckedTextBookName(obj) {
      if (obj.checked) {
        // this.pushTableList(obj, 'add')
        obj.bookPrice.checked = true
        obj.setmealPrice.checked = true
        obj.teachingPrice.checked = true
      } else {
        obj.bookPrice.checked = false
        obj.setmealPrice.checked = false
        obj.teachingPrice.checked = false
        // 一旦勾选错误，就要循环找出数组中是否有相同的并删除
        // this.pushTableList(obj, 'delete')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.el-table__header-wrapper{
  height: 80px;
}
/deep/ .el-table th{
    background-color: white ;
}

</style>
